import { useState } from "react";
import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";

export default function HotArticlesCarousel() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const articles = hotArticles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Title */}
          <div className="mb-10 md:mb-14">
            <h2 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight">
              🔥 本周焦点爆料
            </h2>
            <p className="text-foreground-500 text-base mt-3 max-w-lg">
              精选本周最劲爆的娱乐八卦，全网独家首发追踪
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {articles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className={`group relative overflow-hidden rounded-2xl md:rounded-3xl transition-all duration-700 ease-out ${
                  hoveredIndex === index ? "md:scale-[1.02]" : ""
                } ${index === 0 ? "md:col-span-1" : ""}`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className={`relative ${index === 0 ? "aspect-[3/4]" : "aspect-[3/4]"}`}>
                  {/* Image */}
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                  {/* Hot Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500 text-white text-xs font-bold">
                      <i className="ri-fire-line" />
                      爆
                    </span>
                  </div>

                  {/* Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-1 rounded-md bg-white/15 backdrop-blur-sm text-white/80 text-xs mb-3">
                      {article.categoryName}
                    </span>
                    <h3 className="font-heading font-bold text-white text-lg md:text-xl leading-snug mb-2 group-hover:text-primary-300 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p
                      className={`text-white/70 text-sm leading-relaxed transition-all duration-500 ${
                        hoveredIndex === index ? "opacity-100 max-h-20" : "opacity-0 max-h-0 md:opacity-0 md:max-h-0"
                      } overflow-hidden`}
                    >
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-4 mt-3 text-white/50 text-xs">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line" />
                        {article.commentCount}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}